module.exports = __webpack_public_path__ + "static/media/terms_of_use.a2f90950.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/terms_of_use.pdf
// module id = 160
// module chunks = 23